import { render, staticRenderFns } from "./MainBookCompPrintPS.vue?vue&type=template&id=70acfa2f&scoped=true"
import script from "./MainBookCompPrintPS.vue?vue&type=script&lang=js"
export * from "./MainBookCompPrintPS.vue?vue&type=script&lang=js"
import style0 from "./MainBookCompPrintPS.vue?vue&type=style&index=0&id=70acfa2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70acfa2f",
  null
  
)

export default component.exports